/**
 * Feature Settings API
 * Thin wrapper for backend feature configuration endpoints
 */
import { BACKEND_URL } from '@/lib/backendUrl';


export const featureSettingsApi = {
  /**
   * Get hotel feature configuration
   * @param {string} hotelId
   * @returns {Promise} Feature config + pricing + validation errors
   */
  async getFeatures(hotelId) {
    const response = await fetch(`${BACKEND_URL}/api/features/${hotelId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('easystay_token')}`
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch feature configuration');
    }
    
    return response.json();
  },

  /**
   * Update hotel feature configuration
   * @param {string} hotelId
   * @param {object} config - Feature configuration object
   * @returns {Promise} Updated config + pricing
   */
  async updateFeatures(hotelId, config) {
    const response = await fetch(`${BACKEND_URL}/api/features/${hotelId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('easystay_token')}`
      },
      body: JSON.stringify(config)
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail?.message || 'Failed to update feature configuration');
    }
    
    return response.json();
  },

  /**
   * Get all available feature metadata
   * @returns {Promise} Features grouped by category
   */
  async getMetadata() {
    const response = await fetch(`${BACKEND_URL}/api/features/metadata/all`);
    
    if (!response.ok) {
      throw new Error('Failed to fetch feature metadata');
    }
    
    return response.json();
  }
};
